export interface User {
  attributes: UserAttributes;
  profile?: UserProfile;
}

export interface UserProfile {
  skymiles_number: string;
  skymiles_tier: string;
  email: string;
  encrypted_email: string;
  email_domain: string;
  company_name: string;
  available_miles: string;
  amex_card_type: string;
}

export interface UserAttributes {
  is_logged_in: string;
  login_method?: string;
  login_state?: string;
}

export interface BaseAnalytics {
  event_detail: string;
  event: string;
  click?: ClickAttributes;
  page?: PageAttributes;
  site_assets?: Assets[];
  error?: Error[];
  trips?: unknown;
  form?: FormAttributes[];
}

export interface Assets {
  id: string;
  type: string;
  position: string;
  source: string;
  name: string;
  message?: string;
  image_url?: string;
  promo_code?: string;
  value?: string;
  fare_type?: string;
  currency_code?: string;
}

export interface Error {
  type: string;
  code: string;
  message: string;
}

export interface AnalyticsData extends BaseAnalytics {
  user: User;
}

export interface PageAttributes {
  info: {
    legacy_page_name?: string;
    page_type: string;
    subpage_name?: string;
    subpage_type?: string;
    flow_type?: string;
    country?: string;
    language?: string;
    sys_env?: string;
    page_load_time?: string;
    page_name?: string;
    page_url?: string;
    section?: string;
    sub_section?: string;
    previous_page_name?: string;
    previous_page_url?: string;
  };
}

export interface ClickAttributes {
  name: string;
  component_type: string;
  component_name: string;
  type: string;
  page_section: string;
  action: string;
}

export interface MCAnalyticsEvent {
  buttonCode: string;
  buttonLabel: string;
  actionLabel: string;
  interactionType: string;
  headerDesc: string;
}

export interface Field {
  name: string;
  value: string;
}

export interface FormAttributes {
  name: string;
  type: string;
  field?: Field[];
}

export interface CheckboxField {
  name: string;
  value: boolean;
}

export interface TripAttributes {
  details: {
    trip_type: string;
    fly_ready_status: string;
    messaging_status: string;
  };
}
